<script lang="ts"></script>

<hr class="separator">

<style>
	.separator {
		margin: 0;
		border: 1px solid;
		border-color: var(--button-shadow) var(--button-highlight) var(--button-highlight) var(--button-shadow);
	}
</style>
